// extracted by mini-css-extract-plugin
export var container = "styles-module--container--yFQF4";
export var intro = "styles-module--intro--1PUmY";
export var title = "styles-module--title--3OJTa";
export var titleDesc = "styles-module--titleDesc--3g1zf";
export var description = "styles-module--description--2ZfFm";
export var socialContainer = "styles-module--socialContainer--1NOCf";